interface IMapToArray {
  suggest: object;
  keyToSet: string;
  order: boolean;
}
export const mapToArrayForSelect = ({
  suggest = {},
  keyToSet = "",
  order = false,
}: IMapToArray) => {
  const newObj = [];
  const keyValueObject = suggest[keyToSet as keyof typeof suggest];
  if (keyValueObject && typeof keyValueObject === "object") {
    for (const [key, value] of Object.entries(keyValueObject)) {
      order
        ? newObj.push({ label: value, key: value, value: parseInt(key) })
        : newObj.push({ label: key, key: key, value: value });
    }
  } else {
    console.error(`Invalid or missing keyToSet: ${keyToSet}`);
  }

  return newObj;
};

export const removeEmptyFields = (obj: any) => {
  console.log("filterobj", obj);
  for (const propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === "" ||
      obj[propName] === "[]"
    ) {
      delete obj[propName];
    }
  }
  return obj;
};
export interface FilterObject {
  [key: string]: any;
}
export function filterArrayBasedOnObjectKeys(
  data: any[],
  filters: FilterObject
): any[] {
  console.log("filterD", data, filters);
  return data.filter((item: FilterObject) => {
    for (const key in filters) {
      if (Object.hasOwnProperty.call(filters, key)) {
        const filterValue = filters[key];
        const itemValue = item[key];
        console.log("itemValue===", itemValue, "itemkey", key);
        const parts =
          typeof filterValue === "string" &&
          itemValue.split(",").filter((ele: any) => ele != "");
        if (typeof filterValue === "string" && parts.length > 0) {
          // Check if any of the filter values exist in the comma-separated string
          const langValues = filterValue.split(",").map((v) => v.trim());
          if (!langValues.some((value) => itemValue.includes(value))) {
            return false;
          }
        } else if (Array.isArray(filterValue)) {
          // Check if the item value exists in the filter array
          if (!filterValue.includes(itemValue)) {
            return false;
          }
        } else {
          // Check if the item value matches the filter value
          if (itemValue !== filterValue) {
            return false;
          }
        }
      }
    }
    return true; // Item meets all filter criteria
  });
}
export function capitalizeWords(str: any) {
  return str.replace(/\b\w/g, function (match: any) {
    return match.toUpperCase();
  });
}

export function getOptionIndexMulti(x: any, array: any) {
  const data = [];
  for (let i = 0; i < array.length; i++) {
    if (x != null && x == array[i]["value"]) {
      data.push(array[i]);
    }
  }
  return data;
}
export function getOptionIndexMultiForBranch(dataArray: any, mainArray: any) {
  if (
    mainArray &&
    mainArray != null &&
    dataArray &&
    dataArray != null &&
    Array.isArray(dataArray)
  ) {
    return mainArray.filter((el: any) => {
      return dataArray.some((f: any) => {
        return f == String(el.id);
      });
    });
  }
}

export function getOptionIndex(x: any, array: any) {
  for (let i = 0; i < array.length; i++) {
    if (array[i]["value"] == x) {
      return array[i];
    }
  }
}

export function getOptionIndexMultiWithObject(dataArray: any, mainArray: any) {
  if (
    mainArray &&
    mainArray != null &&
    dataArray &&
    dataArray != null &&
    Array.isArray(dataArray)
  )
    return mainArray.filter((el: any) => {
      return dataArray.some((f: any) => {
        return f.value == el.value;
      });
    });
}
export const returnMultipleValues = (valuesToFind: any, data: any) => {
  return data?.filter((item: any) => valuesToFind?.includes(item.value));
};
